import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1>Privacy Policy</h1>

        <p className="effective-date">
          <strong>Effective Date:</strong> May 2026
        </p>

        <section>
          <p>
            World Dominators Hub Media & Technology Limited is committed to
            protecting your privacy in compliance with the Nigeria Data
            Protection Act.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>

          <ul>
            <li>Personal information (name, email, phone number)</li>
            <li>
              Payment details (processed securely via Flutterwave)
            </li>
            <li>
              Technical and usage data (IP address, browser type, pages visited)
            </li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>

          <ul>
            <li>To deliver and improve our services</li>
            <li>
              To process payments and provide customer support
            </li>
            <li>
              To send updates, invoices, and promotional communications
              (you may opt out anytime)
            </li>
            <li>
              To meet legal and regulatory requirements
            </li>
          </ul>
        </section>

        <section>
          <h2>Sharing of Information</h2>

          <p>
            We may share your data with trusted service providers
            (such as Flutterwave) and as required by law.
            We do not sell your personal data to third parties.
          </p>
        </section>

        <section>
          <h2>Data Security</h2>

          <p>
            We use reasonable security measures to protect your information.
          </p>
        </section>

        <section>
          <h2>Cookies</h2>

          <p>
            We use cookies and similar technologies to enhance your browsing
            experience. You can manage your preferences through your browser.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>

          <p>
            You have the right to access, correct, update, or request deletion
            of your personal data. Contact us to exercise these rights.
          </p>
        </section>

        <section>
          <h2>Changes to this Policy</h2>

          <p>
            We may update this Privacy Policy and will notify you of any
            material changes.
          </p>
        </section>

        <section className="contact-section">
          <h2>Contact Us</h2>

          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:ericdobulertwin26@gmail.com">
              ericdobulertwin26@gmail.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong> +1 (805) 475-3211 OR +1 (914) 691-6155
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;